import React, { Component } from 'react';
import { localConfig, CTMPortalSystemType, initConfig, getCacheAppVersion, setCacheAppVersion, debounce, media, clearCache } from '~/common';
import { getConfig } from '~/client';
import { connect, Provider } from 'react-redux';
import { setAppConfig, setWindowResize } from '~/redux/application';
import { Spin, Icon } from 'antd';
import { injectIntl } from 'react-intl';

class WithConfigRequired extends Component {
    constructor(props) {
        super(props);
        this.resize = debounce(this.resize, 300);
    }

    componentDidMount() {
        getConfig({ token: localConfig.obtApiToken, authServiceProviderType: localConfig.authServiceProviderType }, (_, rs) => this.props.setAppConfig(initConfig(rs || {})));
        window.addEventListener('resize', this.resize);
    }

    componentWillUpdate(nextProps, nextState) {
        const cacheVersion = getCacheAppVersion();
        const version = nextProps.config.version;
        if (version && cacheVersion !== version) {
            clearCache(true);
            setCacheAppVersion(version);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
    }

    resize = () => {
        this.props.setWindowResize({ isMobile: media.isMobile() });
    }

    render() {
        const { config, render, intl, configInitialized, auth } = this.props;
        if (!config || !configInitialized) {
            return (
                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,.85)', textAlign: 'center', zIndex: '999' }}>
                    <Spin tip={intl.formatMessage({ id: 'loading' })} indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />} style={{ position: 'absolute', top: '50%', transform: 'translateY(-50%)', left: 'calc(50% - 30px)', color: 'hsla(0,0%,100%,.9)', fontSize: '1rem' }} />
                </div>
            );
        }
        return render({ config, auth });
    }
}

export default connect(state => ({
    config: state.application.config,
    configInitialized: state.application.configInitialized,
    auth: state.application.auth,
}), dispatch => ({
    setAppConfig: payload => dispatch(setAppConfig(payload)),
    setWindowResize: payload => dispatch(setWindowResize(payload)),
}))(injectIntl(WithConfigRequired));